import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQS = [
  {
    q: "Can you help me with myGov, myID or Centrelink?",
    a: "Yes — this is one of the most common things I help with. I’ll set up myGov and myID (formerly myGovID), link Medicare, Centrelink and the ATO, sort out lock-outs, verification and identity codes, and show you what to do step-by-step.",
  },
  {
    q: "How much does it cost?",
    a: "I charge a fair, flat hourly rate and I’ll always tell you upfront before we start. If a job will be quick, I’ll often just sort it on the spot. No surprises and no callout fees for repeat visits within the same suburb.",
  },
  {
    q: "Do you come to my home?",
    a: "Yes — that’s how I prefer to work. I’ll come to your kitchen table at a time that suits you. I cover Adelaide and surrounding suburbs.",
  },
  {
    q: "I don’t even know what the problem is — is that okay?",
    a: "Absolutely. Just describe it the best you can (“the email isn’t working”, “a pop-up keeps appearing”). We’ll figure it out together.",
  },
  {
    q: "Can you help with scams?",
    a: "Yes. If you think you’ve been targeted, don’t click anything and ring me straight away. I can also do a “safety check-up” of your devices and show you the warning signs to look for in the future.",
  },
  {
    q: "Will you talk to me without using confusing words?",
    a: "That’s the whole point. Plain English, written notes if you’d like them, and I’ll go over things as many times as you need.",
  },
  {
    q: "Can family members book on my behalf?",
    a: "Of course — many of my bookings come from sons, daughters and grandkids. Just pop their name in the form and we’ll go from there.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-24 bg-[#F0F7E8]">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div>
          <p className="text-base md:text-lg font-semibold text-[#6BAF3C] uppercase tracking-wide">Common questions</p>
          <h2 className="mt-3 font-[Work_Sans] text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F2E52]">
            You ask, I’ll explain — gently.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-[#DCE4EC] rounded-2xl px-5 md:px-6"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left text-lg md:text-xl font-[Work_Sans] font-semibold text-[#0F2E52] py-5 hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base md:text-lg text-[#1E3A5F] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
